module.exports = __webpack_public_path__ + "static/media/wavesBig.8ec140c9.svg";